export default __webpack_public_path__ + "static/media/jose--desktop@2x.95713118.jpg";